"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/Feedback/Modals/Rating.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _RatingMeter = require('web/components/VideoCall/Feedback/RatingMeter'); var _RatingMeter2 = _interopRequireDefault(_RatingMeter);
var _LowRatingReason = require('./LowRatingReason'); var _LowRatingReason2 = _interopRequireDefault(_LowRatingReason);
var _withFeedbackController = require('web/screens/VideoCall/Feedback/withFeedbackController'); var _withFeedbackController2 = _interopRequireDefault(_withFeedbackController);


var _helpers = require('web/components/VideoCall/Feedback/helpers');






const RatingModal = ({
  isOpen, onClose,
  lowRatingReasons,
  isRatingSubmitted,
  submitRating,
  submitLowRatingReason,
  submitLowRatingComment,
  sessionDuration,
}) => {
  const [currentRating, setCurrentRating] = _react.useState.call(void 0, 0)
  const [isLowRatingReasonModalOpen, setIsLowRatingReasonModalOpen] = _react.useState.call(void 0, false)

  const handleRatingUpdate = (n) => !isRatingSubmitted &&
    setCurrentRating(n)

  const openLowRatingReasonModal = () => setIsLowRatingReasonModalOpen(true)
  const closeLowRatingReasonModal = _react.useCallback.call(void 0, 
    () => setIsLowRatingReasonModalOpen(false),
    [],
  )

  // Reads the rating of the last render, as the class read `this.state`: a
  // touch on a star updates the rating and submits in the same event.
  const onProceed = () => {
    submitRating(currentRating)
      .then(onClose)
      .catch(openLowRatingReasonModal)
  }

  const backBtnClassName = _classBuilder2.default.call(void 0, 
    "meeting--btn", "secondary",
    "meeting--feedback--rating-modal--back-btn",
    { single: isRatingSubmitted },
  )
  const proceedBtnClassName = _classBuilder2.default.call(void 0, 
    "meeting--btn",
    "meeting--feedback--rating-modal--proceed-btn",
    { hidden: isRatingSubmitted },
    { disabled: currentRating === 0 },
  )
  const noteClassName = _classBuilder2.default.call(void 0, 
    "meeting--feedback--rating-modal--note",
    { hidden: !isRatingSubmitted },
  )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Modal2.default, {
        isOpen: isOpen && !isLowRatingReasonModalOpen,
        onClose: onClose,
        className: "meeting--feedback--rating-modal",
        title: "Call finished" ,
        size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}

        , _react2.default.createElement('span', { className: "meeting--feedback--rating-modal--duration", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
          ,  _helpers.formatSessionDuration.call(void 0, sessionDuration) 
        )
        , _react2.default.createElement('h3', { className: "meeting--feedback--rating-modal--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}, "How was your call?"

        )
        , _react2.default.createElement(_RatingMeter2.default, {
          currentRating: currentRating,
          onRatingUpdate: handleRatingUpdate,
          className: "meting--feedback--rating-modal--meter",
          itemClassName: "meting--feedback--rating-modal--meter-item",
          onRatingSubmit: onProceed,
          isSubmitted: isRatingSubmitted, __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
        )
        , _react2.default.createElement('span', { className: noteClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}, "Your feedback was submitted."

        )
        , _react2.default.createElement('div', { className: "meeting--feedback--rating-modal--btns-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
          , _react2.default.createElement('a', { onClick: onClose, className: backBtnClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}, "Close")
          , _react2.default.createElement('a', { onClick: onProceed, className: proceedBtnClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}, "Rate call" )
        )
      )
      , _react2.default.createElement(_LowRatingReason2.default, {
        isOpen: isLowRatingReasonModalOpen,
        onClose: closeLowRatingReasonModal,
        onReasonSubmit: submitLowRatingReason,
        onCommentSubmit: submitLowRatingComment,
        lowRatingReasons: lowRatingReasons, __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}
      )
    )
  )
}

exports. default = _withFeedbackController2.default.call(void 0, RatingModal)
